import { useCallback } from "react";

import OptionInput from "./OptionInput";
import OtherField from "./OtherField";
import inputConnect from "./inputConnect";

const RadioButtonsInput = props => {
  const {
    value,
    updateValue,
    fieldName,
    isCorrection,
    correctionTextOnlyOnWrongAnswers,
    displayOtherField,
    otherFieldLabel,
    other,
    otherValue,
    filterUnusedOptions
  } = props;

  const isChecked = useCallback(identifier => value === identifier, [value]);

  const currentOptions = props.options;
  const filteredOptionValues = currentOptions.filter(
    option => isChecked(option.id) || option.isCorrect
  );

  const options =
    isCorrection && filterUnusedOptions ? filteredOptionValues : currentOptions;

  const update = useCallback(
    data => {
      const currentData = { value, other, otherValue };

      updateValue({ ...currentData, ...data });
    },
    [other, otherValue, updateValue, value]
  );

  const handleOptionChanged = useCallback(
    ({ target }) => target.checked && update({ value: target.value, other: false }),
    [update]
  );

  const handleOtherChanged = useCallback(
    data => {
      // Clear value if the `other` field was checked
      if (data.other) data.value = null;

      update(data);
    },
    [update]
  );

  return (
    <div className="radio-buttons">
      {options.map(option => (
        <OptionInput
          key={option.id}
          type="radio"
          option={option}
          value={option.id}
          name={fieldName}
          onChange={handleOptionChanged}
          checked={isChecked(option.id)}
          isCorrection={isCorrection}
          correctionTextOnlyOnWrongAnswers={correctionTextOnlyOnWrongAnswers}
        />
      ))}

      <OtherField
        inputType="radio"
        fieldName={fieldName}
        displayOtherField={displayOtherField}
        otherFieldLabel={otherFieldLabel}
        other={other}
        otherValue={otherValue}
        onChange={handleOtherChanged}
      />
    </div>
  );
};

export default inputConnect(RadioButtonsInput, {
  fields: { value: null, other: false, otherValue: "" }
});
